var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('app-jeux-filtre',{attrs:{"filtre":_vm.filtre},on:{"search":_vm.search,"reset":_vm.reset}}),_vm._v(" "),_c('app-jeux-liste',{attrs:{"liste":_vm.listeJeux,"nbJeux":_vm.nbJeux},on:{"next":_vm.next,"select":_vm.select}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.jeuSelect != 0)?_c('app-jeux-details',{attrs:{"idJeu":_vm.jeuSelect},on:{"fermer":function($event){_vm.jeuSelect = 0}}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43c629c2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 31
// module chunks = 0